import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { RemoteApiError } from "../useRemote/types";
import { getOrgBackend } from "../../../app/backend";

type UpdateCostCenterDto = {
  id: string;
  companyId: number;
  name: string;
  costCenterResponsibleMail?: string;
  active?: boolean;
  description?: string;
  color?: string | null;
  aliases?: string[];
};

export function useRemoteUpdateCostCenter(costCenterId: number) {
  return useRemoteMutation<void, RemoteApiError, UpdateCostCenterDto>({
    key: "updateCostCenter",
    url: `${getOrgBackend()}/erp/companies/${costCenterId}/costcenters/manually`
  });
}
